export default {
  error: state => state.error,
  formLoading: state => state.formLoading,
  success: state => state.success,
  loading: state => state.loading,
  company: state => state.company,
  companies: state => state.companies,
  ratings: state => state.ratings,
  category: state => state.category,
  categoryById: state => state.categoryById,
  categoryError: state => state.categoryError,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Companies/getters.js